import React from 'react';

import ExpLabel from '@exp/components/localization/ExpLabel';

import { ModeConfig, ModeContext } from '../constants/modes';
import { selectConfig, selectContext, selectIsHeaderVisible } from '../redux/context';
import { useAppSelector } from '../redux/hooks';
import { TemplateProps } from './types';

import './ModalLayoutV2.less';

/**
 * Modal Layout - V2 Theme
 */
const ModalLayoutV2 = React.forwardRef<HTMLDivElement, TemplateProps>(({ children = null, onClose = null }, ref) => {
  const { program }: ModeContext = useAppSelector(selectContext);
  const { groupCode }: ModeConfig = useAppSelector(selectConfig);
  const isHeaderVisible = useAppSelector(selectIsHeaderVisible);

  return (
    <div className="exp-modal" data-theme="v2" ref={ref}>
      {isHeaderVisible && ( // todo: fill in back/skip
        <div className="exp-modal-header">
          <div className="header-nav">
            <div className="group-code-wrapper vip-notice" data-has-group-code={!!groupCode}>
              <i className="exp-ux-small exp-ux-invite-code" />
              <ExpLabel
                className="vip-text"
                defaultMessage="Invitation Applied"
                messageKey="onb.container.inviteApplied"
              />
            </div>
            <div className="brand-info">
              <img alt={program?.org?.name} className="brand-avatar" src={program?.avatar} />
              <span className="brand-name">{program?.org?.name}</span>
            </div>
            {onClose && (
              <button aria-label="Close" className="exp-modal-close btn-wp-reset" onClick={onClose} type="button">
                <i className="exp-ux-small exp-ux-close" />
              </button>
            )}
          </div>
          <span className="group-code-wrapper vip-notice vip-text" data-has-group-code={!!groupCode}>
            <ExpLabel defaultMessage="Invitation Applied" messageKey="onb.container.inviteApplied" />
          </span>
        </div>
      )}
      <div className="exp-modal-content">{children}</div>
    </div>
  );
});

ModalLayoutV2.displayName = 'ModalLayoutV2';

export default ModalLayoutV2;
